module.exports = __webpack_public_path__ + "static/chariteat-cfc926dcba4458846d5d58364817c7af.svg";